import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import API from "../../services/API";

import { TokenService } from "../../services/LocalStorage";

import { RootState } from "../store";
import { getAssetsByRequest, getFilesByRequest } from "./RequestStore";
import i18next from "i18next";

interface Rule {
  ruleID: string;
  ruleName: string;
}

interface RuleState {
  list: Rule[];
  requestID: string;
  mode: number; // 0: Mostrar relgas, 1: se encontra una regla y se creo la solicitud, 2: listado de reglas, 3:No se encontraron reglas
  isCallingServer: boolean;
}

const initialState: RuleState = {
  list: [],
  requestID: "",
  mode: 0,
  isCallingServer: false
};

export const RuleStore = createSlice({
  name: 'rule',
  initialState,
  reducers: {
    setRule: (state: { list: Rule[] }, action: PayloadAction<Rule[]>) => {
      state.list = action.payload;
    },
    clearRules: (state: { list: Rule[] }) => {
      state.list = [];
    },
    setRequestID: (
      state: { requestID: string },
      action: PayloadAction<string>
    ) => {
      state.requestID = action.payload;
    },
    setMode: (state: { mode: number }, action: PayloadAction<number>) => {
      state.mode = action.payload;
    },
    setIsCallingServer: (state: { isCallingServer: boolean }, action: PayloadAction<boolean>) => {
      state.isCallingServer = action.payload;
    },
    cleanStore: () => {
      return { ...initialState };
    },
  },
});

export const getRules =
  (
    subject: string,
    description: string,
    username: string,
    by: string,
    companyid: string,
    selectedUserComapnyid: string,
    ci: string,
    files?: any,
    email?: string,
    telefono?: string,
    extension?: string,
    locationSelected?: string,
    departmentSelected?: string
  ) =>
    async (dispatch: any) => {
      try {
        dispatch(setIsCallingServer(true));

        API()
          .post(`Rules/getRule`, {
            token: TokenService.get(),
            OnBehalfTo: by,
            Description: description,
            Subject: subject,
            ThroughOf: 300,
            email: email,
            telefono: telefono,
            extension: extension,
            locationSelected: locationSelected,
            departmentSelected: departmentSelected,
          })
          .then((response) => {
            const data: Rule[] = [];

            if (response.data.Values.Values === "[]") {
              // SE CREO
              dispatch(setMode(1));
              if (by === username || companyid === selectedUserComapnyid)
                dispatch(setRequestID(response.data.Values.RequestID));
              else dispatch(setRequestID("-1"));
              if (ci) {
                if (ci !== "none")
                  dispatch(associateCI(ci, response.data.Values.RequestID));
              }
              if (files) {
                files.map((file: File) => {
                  dispatch(uploadFile(response.data.Values.RequestID, file));
                  return null;
                });
              }
            } else if (response.data.Values.Values.length > 0) {
              // PARA ESCOGER
              dispatch(setMode(2));

              response.data.Values.Values.forEach((RuleItem: any) => {
                data.push({
                  ruleID: RuleItem.ReglaID,
                  ruleName: RuleItem.ReglaNom,
                });
              });
            } else {
              // CRREAR CON METODO 2
              dispatch(setMode(3));
            }
            dispatch(setRule(data));
          }).catch((error: unknown) => {

          }).finally(() => {
            dispatch(setIsCallingServer(false));
          });
      } catch (e: any) {
        console.error(e.message);
      }
    };

export const sendRuleRequest =
  (
    subject: string,
    description: string,
    ruleID: string,
    username: string,
    by: string,
    companyid: string,
    selectedUserComapnyid: string,
    ci?: string,
    files?: any,
    email?: string,
    telefono?: string,
    extension?: string,
    locationSelected?: string,
    departmentSelected?: string
  ) =>
    async (dispatch: any) => {
      try {
        dispatch(setIsCallingServer(true));

        API()
          .post(`Rules/getRule`, {
            token: TokenService.get(),
            OnBehalfTo: by,
            Description: description,
            Subject: subject,
            ThroughOf: 300,
            ReglaID: ruleID,
            email: email,
            telefono: telefono,
            extension: extension,
            locationSelected: locationSelected,
            departmentSelected: departmentSelected,
          })
          .then((response) => {
            if (by === username || companyid === selectedUserComapnyid)
              dispatch(setRequestID(response.data.Values.RequestID));
            else dispatch(setRequestID("-1"));
            if (ci) {
              if (ci !== "none")
                dispatch(associateCI(ci, response.data.Values.RequestID));
            }

            if (files) {
              files.map((file: File) => {
                dispatch(uploadFile(response.data.Values.RequestID, file));
                return null;
              });
            }
          }).catch((error: unknown) => {

          }).finally(() => {
            dispatch(setIsCallingServer(false));
          });
      } catch (e: any) {
        return console.error(e.message);
      }
    };

export const createSimpleRequest =
  (
    subject: string,
    description: string,
    username: string,
    by: string,
    companyid: string,
    selectedUserComapnyid: string,
    serviceID: string,
    ci?: string,
    files?: any,
    email?: string,
    telefono?: string,
    extension?: string,
    locationSelected?: string,
    departmentSelected?: string,
    setLoading?: Function
  ) =>
    async (dispatch: any) => {
      try {
        dispatch(setIsCallingServer(true));
        API()
          .post(`services/createrequest`, {
            token: TokenService.get(),
            OnBehalfTo: by,
            Description: description,
            Subject: subject,
            Nature: 4,
            ServiceID: serviceID,
            ThroughOf: 300,
            email: email,
            telefono: telefono,
            extension: extension,
            locationSelected: locationSelected,
            departmentSelected: departmentSelected,
          })
          .then((response) => {
            if (by === username)
              dispatch(setRequestID(response.data.Values.RequestID));
            else if (by !== username) {
              dispatch(setRequestID(""));
            } else dispatch(setRequestID("-1"));

            if (ci) {
              if (ci !== "none")
                dispatch(associateCI(ci, response.data.Values.RequestID));
            }

            if (files) {
              dispatch(uploadFile(response.data.Values.RequestID, files));
              // files.map((file: File) => {
              //   dispatch(uploadFile(response.data.Values.RequestID, file));
              //   return null;
              // });
            }
          }).catch((error: unknown) => {
          }).finally(() => {
            setLoading && setLoading(false);
            dispatch(setIsCallingServer(false));
          });
      } catch (e: any) {
        return console.error(e.message);
      }
    };

export const associateCI =
  (ci: string, requestID: string) => async (dispatch: any) => {
    try {
      API()
        .post(`assets/AssociateCIToRequest`, {
          token: TokenService.get(),
          requestID: requestID,
          ciList: [
            {
              CIID: ci,
              CIName: "",
              Impact: "",
            },
          ],
        })
        .then(() => {
          dispatch(getAssetsByRequest(requestID));
        });
    } catch (e: any) {
      return console.error(e.message);
    }
  };

export const removeCI =
  (ci: string, requestID: string) => async (dispatch: any) => {
    try {
      API()
        .post(`assets/RemoveCIFromRequest`, {
          token: TokenService.get(),
          requestID: requestID,
          ciID: ci,
        })
        .then(() => {
          dispatch(getAssetsByRequest(requestID));
        });
    } catch (e: any) {
      return console.error(e.message);
    }
  };

export const validateFile = (file: File) => async () => {

  var bodyFormData = new FormData();

  bodyFormData.append("files", file);

  return await API()
    .post(`File/PostFile`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      if (response.status === 406) {
        toast.error(`El archivo ${file.name} no es permitido`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          toastId: response.status
        });
        return false;
      } else {
        toast.success(`Subiendo ${file.name}`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "create-reuqest-success",
        });
        return { isValidStatus: true, guid: response.data.guid };
      }
    })
    .catch((e: any) => {
      if (e.message === 'Request failed with status code 406') {
        return toast.error(`El archivo ${file.name} no es permitido`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          toastId: e.message
        });
      }
      return false;
    });
}

// export const uploadFile =
//   (requestID: string, file: any) => async (dispatch: any) => {
//     const isFileValid = dispatch(validateFile(file));
//     isFileValid.then((response: any) => {
//       if (response?.isValidStatus && typeof response != "string") {
//         dispatch(appendFile(requestID, file, response.guid));
//       }
//     })
//   };

export const uploadFile =
  (requestID: string, files: any) => async (dispatch: any) => {
    const formData = new FormData()
    if (files.length > 0) {
      files.map((file: File) => {
        formData.append("files", file);
        return null
      });
    } else {
      
      formData.append('files', files)
    }
    API()
    .post('/File/UploadResource', formData, {
      headers: {
        "x-helppeople-appcode": 1,
        "x-helppeople-actioncode": 1,
        "x-helppeople-useraction": "test",
        "x-helppeople-registerid": requestID,
      },
    })
    .then((response) => {
      dispatch(getFilesByRequest(requestID));
        // console.log(response.data.AcceptedFiles);
        if (response.data.AcceptedFiles.length > 0) {
          toast.success(i18next.t("actives.success"), {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            className: "create-reuqest-success",
          });
          }
          if(response.data.RejectedFiles.length > 0) {
            try {
              response.data.RejectedFiles.map((file:any) => {
                toast.error(`Error al cargar archivo ${file.FileName}: ${file.Error}`, {
                  position: "bottom-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                })
            } catch (error:any) {
              console.error("Error al cargar archivo")
            }
          }
        // toast.success('Carga de adjuntos exitosa', {
        //   position: "bottom-right",
        //   autoClose: 3000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: "create-reuqest-success",
        // });
      })
      .catch((error) => {
        console.error(error);
              toast.error(`Este archivo PDF no es compatible para la carga. Intente convertirlo nuevamente.`, {
                  position: "bottom-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
          });
      });
  };

  // export const uploadFileDinamico =
  // (requestID: string, files: any, user: string ="test") => async (dispatch: any) => {
  //   const formData = new FormData()
  //   if (files.length > 0) {
  //     files.map((file: File) => {
  //       formData.append("files", file);
  //       return null
  //     });
  //   } else {
      
  //     formData.append('files', files)
  //   }
  //   API()
  //   .post(`/File/UploadResourceS3?s3Path=AdjuntoFormularioDinamico/${requestID}`, formData, {
  //     headers: {
  //       "x-helppeople-useraction": user,
  //       "x-helppeople-registerid": requestID,
  //     },
  //   })
  //   .then((response) => {
     
  //     console.log(response.data.RejectedFiles)
  //       if (response.data.AcceptedFiles.length > 0) {
  //         toast.success(i18next.t("actives.success"), {
  //           position: "bottom-right",
  //           autoClose: 3000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //           className: "create-reuqest-success",
  //         });
  //         }
  //         if (Array.isArray(response.data?.RejectedFiles) && response.data.RejectedFiles.length > 0) {
  //           try {
  //             response.data.RejectedFiles.map((file:any) => {
  //               toast.error(`Error al cargar archivo ${file.FileName}: ${file.Error}`, {
  //                 position: "bottom-right",
  //                 autoClose: 5000,
  //                 hideProgressBar: false,
  //                 closeOnClick: true,
  //                 pauseOnHover: true,
  //                 draggable: true,
  //                 progress: undefined,
  //               });
  //               })
  //           } catch (error:any) {
  //             console.error("Error al cargar archivo")
  //           }
  //         }
  //         dispatch(getFilesByRequest(requestID));
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // };
export const appendFile =
  (requestID: string, file: File, guid: string) => async (dispatch: any) => {
    try {
      API()
        .post(`File/UploadFileServiceRequestAsync`, {
          token: TokenService.get(),
          RequestID: requestID,
          files: [
            {
              fileName: file.name,
              mimeType: file.type,
              fileCreatedTime: new Date(),
              fileLength: file.size,
              guid: guid,
            },
          ],
        })
        .then(() => {
          dispatch(getFilesByRequest(requestID));
        });
    } catch (e: any) {
      return console.error(e.message);
    }
  };

export const removeFile =
  (attachmentID: string, requestID: string) => async (dispatch: any) => {
    try {
      API()
        .post(`file/DeleteAttachment`, {
          attachmentID: attachmentID,
          token: TokenService.get(),
        })
        .then(() => {
          dispatch(getFilesByRequest(requestID));
        });
    } catch (e: any) {
      return console.error(e.message);
    }
  };

export const setRules = () => async (dispatch: any) => {
  dispatch(clearRules());
};

export const updateUserInfo =
  (
    Username: string,
    Email: string,
    Phone: string,
    Extention: string,
    DepartmentID: number,
    Location: string,
    TowerId: number,
    FloorId: number
  ) =>
    async (dispatch: any) => {
      try {
        API()
          .post("users/UpdateUserInfo", {
            Token: TokenService.get(),
            Username: Username,
            Email: Email,
            Phone: Phone,
            Extention: Extention,
            DepartmentID: DepartmentID,
            Location: Location,
            TowerId: TowerId,
            FloorId: FloorId,
          })
          .then(() => {
            return null;
          });
      } catch (serviceError: unknown) {
        console.error("[RuleStore] - UpdateUserInfo", serviceError);
      }
    };

export const { setRule, clearRules, setRequestID, setMode, setIsCallingServer, cleanStore } =
  RuleStore.actions;

export const rule = (state: RootState) => state.rule;

export default RuleStore.reducer;
